import { OneTimePurchaseProviders, currencySchema, oneTimePurchaseOptionsSchema, providerResultSchema } from "../../../../payment/shared.mjs";
import { z } from "zod";
//#region src/api/orpc/payment/eventPass/schemas.ts
/**
* Mirror of `EventPassType` / `EventPassStatus` from the server's
* `service/helper/payment/eventPass/constants.ts`. Kept inline so the
* contract package stays free of server-only imports; canonical
* definitions (and the `TYPE_RANK` derivation) stay on the server
* alongside the eventPass service code.
*/
const eventPassTypeSchema = z.enum([
	"FREE",
	"PREMIUM",
	"DELUXE",
	"PREMIUM_TO_DELUXE"
]);
const eventPassStatusSchema = z.enum(["active", "archived"]);
const eventPassSchema = z.object({
	eventName: z.string(),
	type: eventPassTypeSchema,
	rank: z.int().nonnegative(),
	priceAmountMicros: z.coerce.bigint().describe("Raw price in micros (1 base unit = 1,000,000 micros). Used for precise calculations."),
	currency: currencySchema.describe("ISO 4217 currency code"),
	displayAmount: z.string().describe("Formatted display amount in the base currency unit, e.g. \"49.99\" for USD or \"4999\" for JPY. Ready for direct UI rendering."),
	status: eventPassStatusSchema,
	appStoreId: z.string().nullable(),
	googlePlayId: z.string().nullable()
});
const userEventPassSchema = z.object({
	userId: z.coerce.bigint(),
	eventName: z.string(),
	type: eventPassTypeSchema,
	rank: z.int().nonnegative(),
	orderId: z.coerce.bigint(),
	createdAt: z.iso.datetime()
});
const purchaseResultSchema = z.object({
	orderId: z.coerce.bigint(),
	provider: z.enum(OneTimePurchaseProviders),
	userEventPass: userEventPassSchema.optional(),
	providerResult: providerResultSchema.optional()
});
const purchaseInputSchema = oneTimePurchaseOptionsSchema.extend({
	eventName: z.string(),
	eventPassType: z.string(),
	currency: currencySchema
});
//#endregion
export { eventPassSchema, purchaseInputSchema, purchaseResultSchema, userEventPassSchema };
